import { useMemo, useState } from 'react';
import { message } from 'antd';
import { useMutation } from '@apollo/client';
import INSTUCTOR_DELETE from '../mutations/INSTRUCTOR_DELETE';
  
const useInstructorDelete = () => {
    const [ isDeleting, setIsDeleting ] = useState( false );
    const [ deleteMutation ] = useMutation( INSTUCTOR_DELETE  );

    const handleInstructorDelete = async ( id ) => {
        setIsDeleting( true );
        
        try {
            const response = await deleteMutation( { variables: { id: id } } );
            setIsDeleting( false ); 
            
            if ( response.data.deleteInstructor.success ) {
                return true;
            } else {
                return false;
            }
        } catch ( e ) { 
            console.error( e ); 
            message.error( 'Error deleting instructor!' );
            setIsDeleting( false );
        }
    };

    return useMemo( () => {
        return {
            isDeleting,
            deleteInstructor: handleInstructorDelete
        };
    }, [ isDeleting ] );
};

export default useInstructorDelete;
